import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Label, Button, ButtonGroup, Table, Spinner } from "reactstrap";

import { Image } from "react-bootstrap";
import { Formik } from "formik";
import { connect } from "react-redux";
import Select from "react-select";
import "./timesheetStyle.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faPlusCircle,
	faMinusCircle,
	faChevronRight,
	faChevronLeft,
	faBan,
} from "@fortawesome/free-solid-svg-icons";
import { AlertPopups } from "../../components/AlertPopups";
import { UserConsumer } from "../../UserContext";
import { Timesheet_APIs } from "./Timesheet_API";
import axios from "axios";
import cmntImg from "../../images/comment.svg";
import filledCommentImg from "../../images/filledComment.svg";
import moment from "moment";
import Header from "./Header";
import Comment from "./Comment";
import RejectTimesheetModal from "./RejectTimesheetModal";
import InputMask from "react-input-mask";
import {
	FormatGroupOptions,
	minutesToHours,
	hoursToMinutes,
	convertToJSONDate,
	defaultHours,
} from "./timesheet_Variables";
import DatePicker from "react-date-picker";
import { devOpsHoursToTime } from "../../utils";
import devOpsIcon from "../../images/icons/azuredevopsIcon.svg";
import {
	UpdateNavBarItem,
	UpdateNavBarTab,
} from "../../components/navbarRedux/action";
import DevOpsTasksModal from "./DevOpsTasksModal";
import { Routes } from "../../configurations/config";

import homeIcon from "../../images/icons/homeIcon.png";
import officeIcon from "../../images/icons/officeIcon.png";

let token,
	employeeId = null,
	isConsultant = false;
class WeeklyView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			commentC: null,
			taskNameC: null,
			commentDate: "",
			projectId: null,
			projectType: null,
			supervisorComments: "",
			projectList: [],
			groupedOptions: [],
			status: "",
			totalTimeLogged: defaultHours,
			totalHoursThisWeek: defaultHours,
			startDate: moment().weekday(1).format("YYYY-MM-DD"),
			hoursPerProjectPerDay: [],
			hoursPerProjectPerDayDetails: [],
			sumMinutes: "00:00",
			taskList: [],
			countOfDaysLogged: 0,
			tableLoader: true,
			logTimeErr: false,
			internalServerErr: false,
			rejectModal: false,
			devOpsModal: false,
			weekHolidayData: [],
			holidayIndex: null,
			devOpsTasksData: null,
			devOpsDate: null,
		};
		this.handleChange = this.handleChange.bind(this);
		this.deleteTask = this.deleteTask.bind(this);
		this.inputRef = React.createRef();
	}
	componentDidMount() {
		this.projectsNonProjects();
	}
	toggle = () => {
		this.setState((state, props) => ({
			tooltipOpen: !state.tooltipOpen,
		}));
	};
	projectsNonProjects = (prevNextButton) => {
		if (!prevNextButton) {
			let params = new URLSearchParams(window.location.search);
			const week = params.get("week");

			if (week) {
				this.setState(() => ({
					startDate: week,
				}));
				this.props.UpdateNavBarItem("WeeklyView");
				this.props.UpdateNavBarTab("GeneralTasks");
				sessionStorage.setItem("NavbarTab", "GeneralTasks");
				sessionStorage.setItem("NavbarItem", "WeeklyView");
			}
		}
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let groupedOptions = [];
		this.setState({
			groupedOptions: [],
			projectList: [],
			tableLoader: true,
		});
		axios
			.get(
				`${Timesheet_APIs.GetProjects_API}${moment(
					this.state.startDate
				).format("YYYY-MM-DD")}`,
				{ headers: headers }
			)
			.then((res) => {
				res.data.forEach((option) => {
					if (!groupedOptions[option.projectCategory])
						groupedOptions[option.projectCategory] = [];
					groupedOptions[option.projectCategory].push({
						label: option.name,
						value: option.id,
					});
				});
				let result = [];
				result = Object.keys(groupedOptions).map((key) => ({
					label: key,
					options: groupedOptions[key],
				}));
				this.setState(
					{
						groupedOptions: result,
						projectList: res.data,
						internalServerErr: false,
						logTimeErr: false,
						tableLoader: false,
					},
					() => {
						this.hoursWorkedAPI();
						this.populateData();
						setTimeout(() => {
							this.setState({ tableLoader: false });
						}, 1000);
					}
				);
			})
			.catch(() => {
				this.setState({ internalServerErr: true, tableLoader: false });
			});
	};
	hoursWorkedAPI = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${Timesheet_APIs.HoursWorked_API}${this.state.startDate}`, {
				headers: headers,
			})
			.then((res) => {
				let rowTime = [],
					index = 0,
					uRows = 0,
					data = [];
				if (res.data.length !== 0) {
					// creating an array for week dates
					let dates = [];
					dates[0] = this.state.startDate;
					for (let i = 1; i < 7; i++) {
						dates[i] = moment(this.state.startDate, "YYYY-MM-DD")
							.add(i, "days")
							.format("YYYY-MM-DD");
					}
					for (let i = 0; i < dates.length; i++) {
						index = res.data
							.map(function (e) {
								return moment(e.date).format("YYYY-MM-DD");
							})
							.indexOf(dates[i]);
						if (index !== -1) {
							rowTime.push(
								this.formatMinutes(res.data[index].minutes)
							);
						} else {
							rowTime.push("00:00");
							uRows++;
						}
					}
					for (let i = 0; i < uRows; i++) {
						data.push(i);
					}
					this.setState({
						totalHoursThisWeek: rowTime,
						internalServerErr: false,
					});
				} else {
					this.setState({
						totalHoursThisWeek: defaultHours,
					});
				}
			})
			.catch((error) => {
				this.setState({
					totalHoursThisWeek: defaultHours,
					internalServerErr: true,
				});
			});
	};
	formatMinutes = (mins) => {
		//this function convert minutes to time to 00:00 format
		let calculatedHours = mins;
		let hours = Math.floor(calculatedHours / 60);
		let minutes = calculatedHours % 60;
		calculatedHours = hours + ":" + minutes;
		if (hours <= 23) {
			let formatted = moment(calculatedHours, "hh:mm").format("HH:mm");
			return formatted;
		} else {
			return calculatedHours;
		}
	};
	populateData = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Timesheet_APIs.GetWeekInformation}?EmployeeId=${this.props.userDetails.id}&date=${this.state.startDate}`
			)
			.then((res) => {
				this.setState({ weekHolidayData: res.data.dateRecords });
			});
		axios
			.get(
				`${Timesheet_APIs.GetHours_API}?StartDate=${
					this.state.startDate
				}&EndDate=${moment(this.state.startDate)
					.add(6, "days")
					.format("YYYY-MM-DD")}`,
				{ headers: headers }
			)
			.then((res) => {
				let outputarr = [0, 0, 0, 0, 0, 0, 0];
				let newoutputarr = [];
				for (let i in res.data.hoursPerProjectPerDay) {
					for (let j in res.data.hoursPerProjectPerDay[i].details) {
						outputarr[j] += hoursToMinutes(
							String(
								res.data.hoursPerProjectPerDay[i].details[j]
									.hours
							)
						);
					}
				}
				let count = 0;
				for (let a in outputarr) {
					if (outputarr[a] !== 0) {
						count++;
					}
					newoutputarr[a] = minutesToHours(outputarr[a]);
				}
				// creating an array for week dates to display top row
				let dates = [];
				dates[0] = this.state.startDate;
				for (let i = 1; i < 7; i++) {
					dates[i] = moment(this.state.startDate, "YYYY-MM-DD")
						.add(i, "days")
						.format("YYYY-MM-DD");
				}
				if (res.data.hoursPerProjectPerDay.length !== 0) {
					this.setState({
						status: res.data.status,
						supervisorComments: res.data.supervisorComments,
						hoursPerProjectPerDay: res.data.hoursPerProjectPerDay,
						hoursPerProjectPerDayDetails: dates,
						totalTimeLogged: newoutputarr,
						sumMinutes: this.formatTotalHours(res.data.totalHours),
						countOfDaysLogged: count,
						internalServerErr: false,
					});
				} else {
					this.setState({
						status: res.data.status,
						hoursPerProjectPerDay: res.data.hoursPerProjectPerDay,
						hoursPerProjectPerDayDetails: dates,
						internalServerErr: false,
						totalTimeLogged: defaultHours,
					});
				}
			})
			.catch(() => {
				this.setState({
					totalTimeLogged: defaultHours,
					internalServerErr: true,
				});
			});
	};
	getWorkstationForDate(date) {
		
		const matchingRecord = this.state.weekHolidayData.find(record =>
			moment.utc(record.date).isSame(moment.utc(date), 'day')
		);
	  
		// If a matching record is found, return its workstation value; otherwise, return null or a default value
		return matchingRecord ? matchingRecord.workStation : null;
	  }
	formatTotalHours = (mins) => {
		let hours = Math.floor(mins / 60);
		let minutes = mins % 60;
		let sum =
			(hours < 10 ? "0" + hours : hours) +
			":" +
			(minutes < 10 ? "0" + minutes : minutes);
		if (hours <= 23) sum = moment(sum, "hh:mm").format("HH:mm");
		return sum;
	};
	deleteTask = (id) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		AlertPopups.confirmBox
			.fire({
				text: "Delete?",
			})
			.then((result) => {
				if (result.value) {
					return axios
						.delete(`${Timesheet_APIs.Delete_API}${id}`, {
							headers: headers,
						})
						.then((res) => {
							this.setState({ internalServerErr: false });
							AlertPopups.InfoAlert.fire({
								text: "Task deleted",
							});
						})
						.then(() => this.populateData());
				}
			})
			.catch(() => {
				this.setState({
					internalServerErr: false,
				});
			});
	};
	projectValues() {
		return this.state.projectList.map((data) => ({
			label: data.name,
			value: data.id,
		}));
	}

	handleChange = (temp, displayCode, event, data) => {	
		if (displayCode === 1) {
			this.setState({
				[event.name]: temp,
			});
		} else if (displayCode === 2) {
			if (temp.target.value.match("[0-9][0-9]:[0-5][0-9]") != null) {
				const curValue = temp.target.value;
				this.setState((state) => {
					const newData = state.hoursPerProjectPerDay.map((el, i) => {
						const curProject = { ...el };
						if (i == data.index) {
							curProject.details.map((d, indx) => {
								if (indx === data.key1) {
									d.hours = curValue;
								}
								return d;
							});
						}
						return curProject;
					});
					return { hoursPerProjectPerDay: newData };
				});
			}
		} else if (displayCode === 3) {
			let params = new URLSearchParams(window.location.search);
			params.set("week", moment(temp).weekday(1).format("YYYY-MM-DD"));
			this.props.history.push(
				window.location.pathname + "?" + params.toString()
			);
			this.setState(
				{
					startDate: moment(temp).weekday(1).format("YYYY-MM-DD"),
				},
				() => {
					this.projectsNonProjects();
					this.hoursWorkedAPI();
					this.populateData();
				}
			);
		}
	};

	handleBlur = (temp, displayCode, event, item) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		if (displayCode === 1) {
			let postData = {
				taskId: event.taskId,
				taskType: event.taskType,
				date: convertToJSONDate(item.date),
				hours: temp,
			};
			axios
				.put(`${Timesheet_APIs.SaveHoursPerProject}`, postData, {
					headers: headers,
				})
				.then(() => {
					this.setState({ logTimeErr: false });
					this.populateData();
				});
		}
	};

	AddTask = (values) => {
		if (this.state.name) {
			let flag = 0;
			values.name.forEach((val, index) => {
				this.state.hoursPerProjectPerDay.forEach((val2, index2) => {
					if (
						val.value === val2.taskId &&
						val.label === val2.taskName
					) {
						flag = 1;
						AlertPopups.WarningAlert.fire({
							text: "Task Already Exists!",
						});
					}
				});
			});
			if (flag === 0) {
				if (this.state.projectList !== null) {
					let taskIds = [];
					if (this.state.taskList !== null) {
						values.name.forEach((element) => {
							this.state.projectList.forEach((elementChild) => {
								if (
									element.value === elementChild.id &&
									element.label === elementChild.name
								) {
									taskIds.push({
										taskId: elementChild.id,
										taskType: elementChild.type,
									});
								}
							});
						});
						this.setState({ taskList: taskIds }, () => {
							let self = this;
							let data = {
								projectList: this.state.taskList,
								date: moment(this.state.startDate).format(
									"YYYY-MM-DD"
								),
							};
							if (data) {
								const headers = {
									Authorization: `Bearer ${token}`,
								};
								axios
									.post(
										`${Timesheet_APIs.AddProject_API}`,
										data,
										{
											headers: headers,
										}
									)
									.then((response) => {
										if (response.status === 200) {
											this.setState({ name: null });
											AlertPopups.successAlert.fire({
												text: "Task Added",
											});
											this.populateData();
											self.props.history.push(
												Routes.WeeklyView
											);
										}
									})
									.catch((err) => {
										AlertPopups.ErrorAlert.fire({
											text: "Something went wrong",
										});
									});
							}
						});
					}
				}
			}
		} else {
			AlertPopups.ErrorAlert.fire({
				text: "Select A Task",
			});
		}
	};

	CommentRef = (obj) => {
		this.showModal = obj && obj.handleShow;
	};
	onCommentClick = (values, dateP, commentP, isFilled) => {
		this.setState({
			projectId: values.taskId,
			projectType: values.taskType,
			taskNameC: values.taskName,
			commentDate: dateP,
			commentC: commentP,
		});
		if (
			this.state.status.trim() === "Submitted" ||
			this.state.status.trim() === "Approved"
		) {
			if (isFilled) this.showModal();
		} else {
			this.showModal();
		}
	};
	onDevOpsClick = (values, dateP) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Timesheet_APIs.getDevOpsTasks}?EmployeeId=${employeeId}&ProjectName=${values.taskName}&startDate=${dateP}&endDate=${dateP}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					let devOpsData = res.data.sort((a, b) =>
						a.changedDateTime.localeCompare(b.changedDateTime)
					);
					this.setState({
						devOpsModal: true,
						devOpsTasksData: devOpsData.reverse(),
						devOpsDate: dateP,
						projectId: values.taskId,
						taskNameC: values.taskName,
					});
				}
			});
	};
	showModal = () => {};

	saveTimeSheet = (displayCode) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let timeSheetDate = moment(this.state.startDate).format("YYYY-MM-DD");
		let saveData = {
			timeSheetDate: timeSheetDate,
		};
		if (displayCode === 1) {
			axios
				.put(`${Timesheet_APIs.SaveTimeSheet}`, saveData, {
					headers: headers,
				})
				.then((res) => {
					if (res.status === 200) {
						this.populateData();
						AlertPopups.successAlert.fire({
							text: "Saved",
						});
						this.setState({ logTimeErr: false });
					}
				});
		} else if (displayCode === 2) {
			AlertPopups.confirmBox
				.fire({
					text: `${AlertPopups.confirmMsg}`,
				})
				.then((result) => {
					if (result.value) {
						axios
							.put(
								`${Timesheet_APIs.SubmitTimeSheet}`,
								saveData,
								{
									headers: headers,
								}
							)
							.then((res) => {
								if (res.status === 200) {
									this.populateData();
									AlertPopups.successAlert.fire({
										text: "Submitted",
									});
									this.setState({ logTimeErr: false });
								}
							})
							.catch(function (error) {
								if (error.response) {
									AlertPopups.WarningAlert.fire({
										text: error.response.data.message,
									});
								}
							});
					}
				});
		}
	};
	//handle previousNext
	prevNext = (displayCode) => {
		if (displayCode === 1) {
			let params = new URLSearchParams(window.location.search);
			params.set(
				"week",
				moment(this.state.startDate)
					.subtract(1, "weeks")
					.format("YYYY-MM-DD")
			);
			this.props.history.push(
				window.location.pathname + "?" + params.toString()
			);
			this.setState(
				{
					startDate: moment(this.state.startDate)
						.subtract(1, "weeks")
						.format("YYYY-MM-DD"),
				},
				() => {
					this.projectsNonProjects(true);
				}
			);
		} else if (displayCode === 2) {
			let params = new URLSearchParams(window.location.search);
			params.set(
				"week",
				moment(this.state.startDate)
					.add(1, "weeks")
					.format("YYYY-MM-DD")
			);
			this.props.history.push(
				window.location.pathname + "?" + params.toString()
			);
			this.setState(
				{
					startDate: moment(this.state.startDate)
						.add(1, "weeks")
						.format("YYYY-MM-DD"),
				},
				() => {
					this.projectsNonProjects(true);
				}
			);
		}
	};
	validateHours = () => {
		this.saveTimeSheet(2);
	};

	checkHoursDifference = (totalHoursThisWeek, totalTimeLogged) => {
		let flag = false;
		if (
			moment
				.duration(
					moment(totalHoursThisWeek, "hh:mm").diff(
						moment(totalTimeLogged, "hh:mm")
					)
				)
				.asMinutes() > 2 ||
			moment
				.duration(
					moment(totalHoursThisWeek, "hh:mm").diff(
						moment(totalTimeLogged, "hh:mm")
					)
				)
				.asMinutes() < 0
		) {
			flag = true;
		}
		return flag;
	};

	render() {
		if (this.state.tableLoader) {
			return (
				<UserConsumer>
					{(userDetails) => {
						token = userDetails.token;
						isConsultant = userDetails.isConsultant;
						employeeId = userDetails.id;
						return (
							<div className="w-100 h-100 timesheetOverlay">
								<div className="align-items-center d-flex h-100 justify-content-center">
									<Spinner color="secondary" />
								</div>
							</div>
						);
					}}
				</UserConsumer>
			);
		}
		return (
			<UserConsumer>
				{(userDetails) => {
					return (
						<>
							<div className="container-fluid pl-4 pr-4">
								{this.props.location.state?.showBackButton ? (
									<Header
										title="My Timesheet"
										extraTitle={this.state.sumMinutes}
										onClick={() =>
											this.props.history?.push(
												Routes.MyTimeSheetStatus
											)
										}
									/>
								) : (
									<Header
										title="My Timesheet"
										extraTitle={this.state.sumMinutes}
									/>
								)}

								<div className="wrapper">
									<div className="bottomMargin row d-flex">
										<div className="col-lg-6 col-md-12 col-sm-12 mt-lg-2 mr-auto heading">
											Time Logged for the Week
											<span className="m-3 vertical-line"></span>
											{this.state.status && (
												<>
													{(() => {
														switch (
															this.state.status
														) {
															case "Pending":
																return (
																	<span
																		className="ml-0 status-box status-pending"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "InProgress":
																return (
																	<span
																		className="ml-0 status-box status-pending"
																		title="Status"
																	>
																		{
																			"In Progress"
																		}
																	</span>
																);
															case "In Progress":
																return (
																	<span
																		className="ml-0 status-box status-pending"
																		title="Status"
																	>
																		{
																			"In Progress"
																		}
																	</span>
																);
															case "Completed":
																return (
																	<span
																		className="ml-0 status-box status-approved"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "Approved":
																return (
																	<span
																		className="ml-0 status-box status-approved"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "PM Approved":
																return (
																	<span
																		className="ml-0 status-box status-approved"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "Rejected":
																return (
																	<span
																		className="ml-0 status-box status-rejected"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "Reject":
																return (
																	<span
																		className="ml-0 status-box status-rejected"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "PM Rejected":
																return (
																	<span
																		className="ml-0 status-box status-rejected"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "Invalid":
																return (
																	<span
																		className="ml-0 status-box status-invalid"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															case "Submitted":
																return (
																	<span
																		className="ml-0 status-box status-Paid"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
															default:
																return (
																	<span
																		className="ml-0 status-box status-draft"
																		title="Status"
																	>
																		{
																			this
																				.state
																				.status
																		}
																	</span>
																);
														}
													})()}
												</>
											)}
										</div>

										<div className="justify-content-between d-flex">
											<div>
												{this.state.logTimeErr ? (
													<span className="font-small font-weight-light pl-1 text-danger">
														Log time is missing for
														whole week
													</span>
												) : this.state
														.internalServerErr ? (
													<span className="font-small font-weight-light pl-1 text-danger">
														Unable to fetch data,
														please contact Admin.
													</span>
												) : null}
											</div>
											<div className="ml-auto mt-lg-0 mt-md-0 mr-4 text-right">
												<Button
													className="submitTimesheet"
													onClick={() => {
														this.validateHours();
													}}
													disabled={
														this.state.status.trim() ===
															"Submitted" ||
														this.state.status.trim() ===
															"Approved"
													}
												>
													SUBMIT
												</Button>
												<Button
													title="Request for rejection"
													className="submitTimesheet"
													onClick={() => {
														this.setState({
															...this.state,
															rejectModal: true,
														});
													}}
													disabled={
														this.state.status.trim() !=
														"Approved"
													}
												>
													REJECT
												</Button>
												<Button
													className="saveMe"
													onClick={() => {
														this.saveTimeSheet(1);
													}}
													disabled={
														this.state.status.trim() ===
															"Submitted" ||
														this.state.status.trim() ===
															"Approved"
													}
												>
													SAVE
												</Button>
												<ButtonGroup className="arrowButtons">
													<Button
														className="arrowBtn arrowButtonLeft"
														onClick={() => {
															this.prevNext(1);
														}}
														title="Previous"
														disabled={
															moment(
																this.state
																	.startDate
															) <
																moment(
																	userDetails.empJoinedOn
																) ||
															moment(
																this.state
																	.startDate
															).subtract(
																1,
																"weeks"
															) <
																moment(
																	userDetails.empJoinedOn
																)
														}
													>
														<FontAwesomeIcon
															icon={faChevronLeft}
															size="1x"
														/>
													</Button>
													<Button
														className="arrowBtn arrowButtonRight"
														onClick={() =>
															this.prevNext(2)
														}
														title="Next"
														disabled={
															moment(
																this.state
																	.startDate
															).add(1, "weeks") >
															moment()
														}
													>
														<FontAwesomeIcon
															icon={
																faChevronRight
															}
															size="1x"
														/>
													</Button>
												</ButtonGroup>
												<DatePicker
													maxDate={new Date()}
													minDate={
														new Date(
															userDetails.empJoinedOn
														)
													}
													value={
														new Date(
															this.state.startDate
														)
													}
													onChange={(date) =>
														this.handleChange(
															date,
															3,
															new Date(
																userDetails.empJoinedOn
															)
														)
													}
													onChangeRaw={(e) => {
														e.preventDefault();
													}}
													clearIcon={null}
												/>
											</div>
										</div>
									</div>
									<div>
										<span className="publicHolidayColor"></span>
										<span className="font-small font-weight-light pl-1">
											Public Holiday
										</span>
									</div>

									<div>
										<span className="leaveColor"></span>
										<span className="font-small font-weight-light pl-1">
											Employee Personal Leave
										</span>
									</div>

									{/*Reject timesheet Modal */}
									<RejectTimesheetModal
										showModal={this.state.rejectModal}
										handleClose={() => {
											this.setState({
												...this.state,
												rejectModal: false,
											});
										}}
										commentHeading="Reason for rejection"
										rejectionDate={
											this.state
												.hoursPerProjectPerDayDetails[0]
										}
										handleOnSubmit={(reason, date) => {
											axios
												.post(
													Timesheet_APIs.RequestRejectTimesheet,
													{
														timesheetDate: date,
														reason: reason,
													},
													{
														headers: {
															Authorization: `Bearer ${token}`,
														},
													}
												)
												.then((res) => {
													if (res.status === 200) {
														AlertPopups.successAlert.fire(
															{
																text: "Request for rejection successfully submitted",
															}
														);
													}
												})
												.catch((err) => {
													AlertPopups.ErrorAlert.fire(
														{
															text: err.response
																.data.message,
														}
													);
												})
												.finally(() => {
													this.setState({
														...this.state,
														rejectModal: false,
													});
												});
										}}
									/>
									{/*DevOps Task Modal */}
									<DevOpsTasksModal
										showModal={this.state.devOpsModal}
										taskName={this.state.taskNameC}
										devOpsTasksData={
											this.state.devOpsTasksData
										}
										devOpsDate={this.state.devOpsDate}
										handleClose={() => {
											this.setState({
												...this.state,
												devOpsModal: false,
											});
										}}
									/>
									{this.state.tableLoader ? (
										<div className="w-100 h-100 timesheetOverlay">
											<div className="align-items-center d-flex h-100 justify-content-center">
												<Spinner color="secondary" />
											</div>
										</div>
									) : (
										<div>
											<Formik
												initialValues={this.state}
												validateOnChange={true}
												enableReinitialize={true}
											>
												{({
													errors,
													touched,
													handleBlur,
													handleSubmit,
												}) => (
													<form
														onSubmit={handleSubmit}
														className="timeForm mt-4"
													>
														<Comment
															data={[
																this.state
																	.projectId,
																this.state
																	.projectType,
																this.state
																	.commentC,
																this.state
																	.commentDate,
																this.state
																	.taskNameC,
																this.state
																	.status,
																this
																	.populateData,
															]}
															ref={
																this.CommentRef
															}
														></Comment>
														<Table
															responsive="xl"
															borderless
															className="timesheetTable"
														>
															<thead className="thead">
																<tr>
																	<th
																		style={{
																			width: "16%",
																			paddingBottom:
																				"26px",
																		}}
																	>
																		Task
																	</th>
																	{this.state.hoursPerProjectPerDayDetails.map(
																		(
																			day,
																			key4
																		) => {
																			const workstationForDate = this.getWorkstationForDate(day);
																	
																			return (
																				<>
																					<th
																						key={
																							key4
																						}
																					>
																						<div className="pb-1">
																							{moment(
																								day
																							).format(
																								"dddd"
																							)}
																							{workstationForDate === "Work From Home"  ? (
          <Image
            src={homeIcon}
            className="homeIcon"
            alt="home"
            title="Work from Home"
          />
        ) : (
          workstationForDate === "Work From Office" || workstationForDate==="Continuing work from office" ? (
            <Image
              src={officeIcon}
              className="officeIcon"
              alt="office"
              title="Work from Office"
            />
          )
		  
		  : null
        )}
																						</div>
																						<div className="dateClass">
																							{moment(
																								day
																							).format(
																								"MMM Do"
																							)}
																						</div>
																						
																					</th>
																				</>
																			);
																		}
																	)}
																	<th colSpan="2"></th>
																</tr>
															</thead>
															<tbody className="tbody">
																{!isConsultant && (
																	<tr className="hoursWeek">
																		<td
																			style={{
																				width: "16%",
																			}}
																		>
																			Hours
																			this
																			week
																		</td>
																		{this.state.totalHoursThisWeek.map(
																			(
																				time,
																				key2
																			) => {
																				return (
																					<td
																						title={
																							(this
																								.state
																								.weekHolidayData[
																								key2
																							]
																								?.isCalendarHoliday &&
																								"Public Holiday") ||
																							(this
																								.state
																								.weekHolidayData[
																								key2
																							]
																								?.isLeave &&
																								"Employee Personal Leave")
																						}
																						key={
																							key2
																						}
																						style={{
																							width: "12%",
																						}}
																					>
																						<span
																							data-value={time.trim()}
																							className={`weekHoursClass ${
																								this
																									.state
																									.weekHolidayData[
																									key2
																								]
																									?.isCalendarHoliday
																									? "holidayIndication"
																									: null
																							} ${
																								this
																									.state
																									.weekHolidayData[
																									key2
																								]
																									?.isLeave
																									? "leaveIndication"
																									: null
																							} ${
																								this.checkHoursDifference(
																									this
																										.state
																										.totalHoursThisWeek[
																										key2
																									],
																									this
																										.state
																										.totalTimeLogged[
																										key2
																									]
																								) &&
																								"conditionalClass"
																							}`}
																						>
																							{time.trim()}
																						</span>
																					</td>
																				);
																			}
																		)}
																		<td></td>
																		<td></td>
																	</tr>
																)}
																<tr className="hoursLogged">
																	<td
																		style={{
																			width: "16%",
																		}}
																	>
																		Total
																		time
																		logged
																	</td>
																	{this.state.totalTimeLogged.map(
																		(
																			item,
																			key
																		) => (
																			<td
																				title={
																					(this
																						.state
																						.weekHolidayData[
																						key
																					]
																						?.isCalendarHoliday &&
																						"Public Holiday") ||
																					(this
																						.state
																						.weekHolidayData[
																						key
																					]
																						?.isLeave &&
																						"Employee Personal Leave")
																				}
																				key={
																					key
																				}
																				style={{
																					width: "12%",
																				}}
																			>
																				<span
																					data-value={item.trim()}
																					className={`weekHoursClass ${
																						this
																							.state
																							.weekHolidayData[
																							key
																						]
																							?.isCalendarHoliday
																							? "holidayIndication"
																							: null
																					} ${
																						this
																							.state
																							.weekHolidayData[
																							key
																						]
																							?.isLeave
																							? "leaveIndication"
																							: null
																					} ${
																						this.checkHoursDifference(
																							this
																								.state
																								.totalHoursThisWeek[
																								key
																							],
																							this
																								.state
																								.totalTimeLogged[
																								key
																							]
																						) &&
																						"conditionalClass"
																					}`}
																				>
																					{item.trim()}
																				</span>
																			</td>
																		)
																	)}
																	<td></td>
																	<td></td>
																</tr>
															</tbody>
															<thead className="rowStyle0">
																<tr>
																	<th>
																		<Label id="selection">
																			Select
																			an
																			activity
																		</Label>
																	</th>
																	<th colSpan="7">
																		<Select
  placeholder="Select project"
  isMulti
  name="name"
  id="name"
  onChange={(value, event) => this.handleChange(value, 1, event)}
  onMenuOpen={() => this.setState({ menuOpen: true })}
  onMenuClose={() => this.setState({ menuOpen: false })}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      if (this.state.menuOpen) {
         return;
      }
      e.preventDefault();
      this.AddTask(this.state);
    }
  }}
  bsSize="sm"
  value={this.state.name}
  options={this.state.groupedOptions}
  formatGroupLabel={FormatGroupOptions}
  isClearable
  isDisabled={
    this.state.status.trim() ==="Submitted" ||
    this.state.status.trim() ==="Approved"
  }
/>
																		{errors.taskList &&
																			touched.taskList && (
																				<div className="input-feedback">
																					{
																						errors.taskList
																					}
																				</div>
																			)}
																	</th>
																	<th className="faIconBtn">
																		<Button
																			title="Add Project"
																			className="addButton p-0"
																			disabled={
																				this.state.status.trim() ===
																					"Submitted" ||
																				this.state.status.trim() ===
																					"Approved"
																			}
																			onClick={(
																				values
																			) =>
																				this.AddTask(
																					this
																						.state
																				)
																			}
																		>
																			<FontAwesomeIcon
																				className="plusCircle"
																				icon={
																					faPlusCircle
																				}
																			/>
																		</Button>
																	</th>
																	<th></th>
																</tr>
															</thead>

															<tbody>
																{this.state.hoursPerProjectPerDay.map(
																	(
																		d,
																		index
																	) => {
																		return (
																			<tr
																				key={
																					index
																				}
																				className={
																					index %
																						2 ===
																					0
																						? "rowStyle1"
																						: "rowStyle2"
																				}
																			>
																				<td>
																					<Label
																						className="Namelabels"
																						id="Namelabels"
																					>
																						{d.taskName.substring(
																							0,
																							35
																						)}
																					</Label>
																				</td>

																				{d.details.map(
																					(
																						item,
																						key1
																					) => {
																						return (
																							<td
																								key={
																									key1
																								}
																							>
																								<div className=" row ml-0 testTimesheet">
																									<InputMask
																										mask="99:99"
																										className="timeClass"
																										value={
																											item.hours
																										}
																										disabled={
																											moment(
																												item.date
																											) >=
																												moment() ||
																											this.state.status.trim() ===
																												"Submitted" ||
																											this.state.status.trim() ===
																												"Approved"
																										}
																										onChange={(
																											value,
																											event
																										) =>
																											this.handleChange(
																												value,
																												2,
																												event,
																												{
																													index,
																													key1,
																												}
																											)
																										}
																										onBlur={(
																											e
																										) =>
																											this.handleBlur(
																												e
																													.target
																													.value,
																												1,
																												d,
																												item,
																												index
																											)
																										}
																									/>

																									{item.comments ===
																									"" ? (
																										<img
																											src={
																												cmntImg
																											}
																											title="Comments"
																											alt="comments"
																											className="faCommentBtn"
																											val={
																												item.comments
																											}
																											onClick={() =>
																												this.onCommentClick(
																													d,
																													item.date,
																													item.comments,
																													false
																												)
																											}
																											height={
																												"15px"
																											}
																											width={
																												"15px"
																											}
																										/>
																									) : (
																										<img
																											src={
																												filledCommentImg
																											}
																											title="Comments"
																											alt="filledcomments"
																											className="faCommentBtn"
																											val={
																												item.comments
																											}
																											onClick={() =>
																												this.onCommentClick(
																													d,
																													item.date,
																													item.comments,
																													true
																												)
																											}
																											height={
																												"15px"
																											}
																											width={
																												"15px"
																											}
																										/>
																									)}
																								</div>
																								<div
																									className="mx-2 my-1 devOpsHours"
																									style={{
																										justifyContent:
																											"space-around",
																									}}
																								>
																									{item.devopsHours >
																									0 ? (
																										<span
																											className="devOpsHoursLink"
																											onClick={() =>
																												this.onDevOpsClick(
																													d,
																													item.date
																												)
																											}
																										>
																											{devOpsHoursToTime(
																												item.devopsHours
																											)}
																										</span>
																									) : (
																										"00:00"
																									)}
																									<img
																										src={
																											devOpsIcon
																										}
																										alt="devOps"
																										title="DevOps Hours"
																										height={
																											"14px"
																										}
																										width={
																											"14px"
																										}
																									/>
																								</div>
																							</td>
																						);
																					}
																				)}

																				<td className=" faIconBtn">
																					<Button
																						title="Delete"
																						className="minusButton p-0"
																						disabled={
																							this.state.status.trim() ===
																								"Submitted" ||
																							this.state.status.trim() ===
																								"Approved"
																						}
																						onClick={() => {
																							if (
																								d.defaultProject ===
																								false
																							)
																								this.deleteTask(
																									d.worksheetTaskId
																								);
																						}}
																					>
																						{d.defaultProject ===
																						false ? (
																							<FontAwesomeIcon
																								className="minusCircle p-0"
																								icon={
																									faMinusCircle
																								}
																								size="1x"
																							/>
																						) : (
																							<FontAwesomeIcon
																								className="minusCircle"
																								icon={
																									faBan
																								}
																								size="1x"
																							/>
																						)}
																					</Button>
																				</td>
																				<td></td>
																			</tr>
																		);
																	}
																)}
															</tbody>
														</Table>
													</form>
												)}
											</Formik>
										</div>
									)}
									<hr />
									<div>
										<p className="sComments">
											Supervisor's Comments
										</p>
									</div>
									<textarea
										className="commentSection mb-4"
										maxLength="50"
										disabled
										value={
											this.state.supervisorComments !==
											null
												? this.state.supervisorComments
												: "No comments added by supervisor"
										}
									/>
								</div>
							</div>
						</>
					);
				}}
			</UserConsumer>
		);
	}
}
const mapDispatchToProps = {
	UpdateNavBarItem,
	UpdateNavBarTab,
};
export default connect(null, mapDispatchToProps)(WeeklyView);
